import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useLocalStorage, useSettings } from './hooks/useLocalStorage'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Practice from './pages/Practice'
import TestMode from './pages/TestMode'
import Interview from './pages/Interview'
import Notes from './pages/Notes'
import Settings from './pages/Settings'
import AdminStub from './pages/AdminStub'
import NotFound from './pages/NotFound'
import DefenceNews from './pages/DefenceNews'
import QuestionManager from './pages/QuestionManager'

function App() {
  const [state, setState, updateState] = useLocalStorage()
  const { settings, toggleTheme, setFontSize } = useSettings(state, updateState)

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <div className="flex flex-col min-h-screen">
        <Header settings={settings} toggleTheme={toggleTheme} />
        
        <main id="main-content" className="flex-1 container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home state={state} />} />
            <Route path="/practice" element={<Practice state={state} updateState={updateState} />} />
            <Route path="/test" element={<TestMode state={state} updateState={updateState} />} />
            <Route path="/interview" element={<Interview state={state} updateState={updateState} />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/news" element={<DefenceNews />} />
            <Route path="/question-manager" element={<QuestionManager />} />
            <Route 
              path="/settings" 
              element={
                <Settings 
                  state={state} 
                  setState={setState}
                  settings={settings}
                  setFontSize={setFontSize}
                />
              } 
            />
            <Route path="/admin" element={<AdminStub />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
